export default __webpack_public_path__ + "static/media/fruhlingsblumen.08ed15f1.webp";